import React from "react";
import { Truck, Shield, Star, Smile } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: <Truck className="w-8 h-8 text-pink-600" />,
    title: "Fast & Free Delivery",
    description: "Get your orders delivered quickly with no extra cost."
  },
  {
    icon: <Shield className="w-8 h-8 text-pink-600" />,
    title: "Secure Payments",
    description: "All transactions are 100% secure and encrypted."
  },
  {
    icon: <Star className="w-8 h-8 text-pink-600" />,
    title: "Top Quality Products",
    description: "We provide only the best quality products for you."
  },
  {
    icon: <Smile className="w-8 h-8 text-pink-600" />,
    title: "Customer Satisfaction",
    description: "Our customers are our top priority, always."
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 bg-pink-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          className="text-4xl font-bold text-pink-600 mb-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Why Choose Us
        </motion.h2>
        <motion.p
          className="text-gray-700 text-lg mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          We offer exceptional service and products that stand out in quality and reliability.
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div className="flex justify-center mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
